import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import SummaryApi from '../common'; 
import ROLE from '../common/role';
import { useNavigate } from 'react-router-dom'; 
import displayINRCurrency from '../helpers/displayCurrency';
import { useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 

const SalesmanPaymentRequest = () => {
  
  const [userId, setUserId] = useState(''); 
  const [selectedOrganization, setSelectedOrganization] = useState(''); 
  const [amountToPay, setAmountToPay] = useState(''); 
  const [loading, setLoading] = useState(false); 
  const [salesmen, setSalesmen] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [noSalesmenMessage, setNoSalesmenMessage] = useState('');
  const [selectedSalesmanDetails, setSelectedSalesmanDetails] = useState({});
  const user = useSelector(state => state?.user?.user);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => {
      setLoading(false);
      navigate("/");
    }, 10000); 

    if (user) {
      if ( user?.role !== ROLE.SALESMAN) {
        navigate("/");
        setLoading(false);
      } else {
        setLoading(false);
        clearTimeout(loadingTimeout);
        fetchUserDetails();
      }
    } 

    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(SummaryApi.current_user.url, {
        method: SummaryApi.current_user.method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        toast.error(`حدث خطأ`);
        return;
      }

      const result = await response.json();

      if (result.success) {
        setUserId(result.data._id);
        
      } else {
        toast.error(result.message || 'حدث خطأ');
      }
    } catch (error) {
      toast.error('حدث خطأ');
    } 
  }

  const handlePaymentRequest = async () => {
    if (!amountToPay || amountToPay <= 0) {
      toast.error('من فضلك قم بادخال رقم صحيح للسداد');
      return;
    }

    if (!selectedUser || !selectedOrganization) {
      toast.error('لا يمكنك تنفيذ طلب دفع بدون اختيار جهة الدفع و الصيدلية المراد التسديد لها');
      return;
    }


    try {
        setLoading(true);

        const response = await fetch(SummaryApi.deptRequestOTP.url, {
          method: SummaryApi.deptRequestOTP.method,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userId: selectedUser,
            deptQuantity: amountToPay,
           salesManEmail:user?.email
          }),
        });



        /*
        const response = await fetch(SummaryApi.deptPaymentController.url, {
          method: SummaryApi.deptPaymentController.method,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userId:  selectedUser,
            deptQuantity: amountToPay,
            state: "accepted",
            type: "Medicine", 

            salesManId: userId,
            salesManName: user?.name,
            salesManEmail: user?.email,
            salesManMobileNumber:user?.mobileNumber,
            userMobileNumber:selectedSalesmanDetails.mobileNumber,
            userName:selectedSalesmanDetails.name,
            userShippingAddress:selectedSalesmanDetails.shippingAddress,
            email:selectedSalesmanDetails.email,
          }),
        });
    */
        const result = await response.json();
    
        if (result.success) {
          toast.success('تم ارسال رمز التحقق لمسئول المبيعات بنجاح');
          
          // Navigate to paymentOTPVerify page with required state parameters
          navigate('/salesManPaymentOTPVerify', {
            state: {
              userId: selectedUser,
              deptQuantity: amountToPay,
              type: "Medicine",
              salesManId: userId,
              salesManName: user?.name,
              salesManEmail: user?.email,
              salesManMobileNumber: user?.mobileNumber
            }
            
          });
  
        } else {
          toast.error(result.message || 'فشل طلب سداد المديونية');
        }
      } catch (error) {
      toast.error('فشل طلب سداد المديونية');
    } finally {
      setLoading(false);
    }
};

  

  const salesmanFetchUsers = async () => {
    try {
      const response = await fetch(SummaryApi.salesManGetUsers.url, {
        method: SummaryApi.salesManGetUsers.method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
       
      });
  
      const result = await response.json();
  
      if (result.success) {
        if (result.data.length === 0) {
          setNoSalesmenMessage('لا يوجد مسئولين مبيعات لهذه الشركة حاليا');
          setSalesmen([]);
        } else {
          setNoSalesmenMessage('');
          setSalesmen(result.data);
        }
      } else {
        toast.error(result.message || 'حدث خطأ');
      }
    } catch (error) {
      toast.error('حدث خطأ');
    }
  };
  

  const handleOrganizationChange = (e) => {
    const selectedType = e.target.value;
    setSelectedOrganization(selectedType);
    setSelectedUser('');
    setSalesmen([]); 
    setNoSalesmenMessage(''); 
    setSelectedSalesmanDetails({}); 
    salesmanFetchUsers(selectedType);
  };

  const handleUserChange = (e) => {
    const selectedUserId = e.target.value;
    setSelectedUser(selectedUserId);

    // Find selected salesman details
    const selectedSalesman = salesmen.find(salesman => salesman._id === selectedUserId);
    setSelectedSalesmanDetails(selectedSalesman || {});
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
    );
  }

  return (
    <div className='container max-w-5xl mx-auto p-5 mr-20'>
      <div className='flex flex-col md:flex-row'>
        <div className='w-full md:w-2/3 pr-0 md:pr-20 mb-4 md:mb-0'>
          <div className='bg-white border rounded-lg shadow-md p-5'>
            <h2 className='text-2xl font-bold mb-5 text-center'>طلب سداد المديونية</h2>

            {loading ? (
              <div className="h-32 bg-slate-200 animate-pulse"></div>
            ) : (
              <>


                <div className='mb-4'>
                  <label htmlFor='organization' className='block text-lg font-medium mb-2 text-right'>اختر جهة الدفع</label>
                  <select
                    id='organization'
                    className='border rounded p-2 w-full'
                    value={selectedOrganization}
                    onChange={handleOrganizationChange}
                  >
                    <option value='' disabled>من فضلك اختر الشركة التي تريد الدفع لها</option>
                    <option value='Medicine'>شركة دواكو</option>
                  </select>
                </div>
                
                {noSalesmenMessage ? (  
                  <div className='mb-4 text-red-500'>
                    {noSalesmenMessage}
                  </div>
                ) : (
                  selectedOrganization && (
                    <div className='mb-4'>
                      <label htmlFor='salesman' className='block text-lg font-medium mb-2 text-right'>
                        {salesmen.length === 0 ? 'لا يوجد صيدليات تابعه للشركة حاليا' : 'من فضلك اختر الصيدلية المراد تسديد المديونية لها'}
                      </label>
                      <select
                        id='salesman'
                        className='border rounded p-2 w-full'
                        value={selectedUser}
                        onChange={handleUserChange}
                        disabled={salesmen.length === 0}
                      >
                        <option value='' disabled>{salesmen.length === 0 ? 'لا يوجد صيدليات حاليا ' : 'اختر الصيدلية المراد التسديد لها '}</option>
                        {salesmen.map(salesman => (
                          <option key={salesman._id} value={salesman._id}>
                            {salesman.name}
                          </option>
                        ))}
                      </select>
                     
                    </div>
                  )
                )}
               {selectedSalesmanDetails.name && (  <div className='mb-4'>
                  <h3 className='text-lg font-bold mb-3 text-right'> اجمالى مديونية الصيدلية</h3>
                  <p className="border rounded p-2 bg-gray-50 text-lg font-semibold">{displayINRCurrency (Number(selectedSalesmanDetails.medicineDebt.$numberDecimal).toFixed(2))} </p>
                </div>)}

                <div className='mb-4'>
                  <label htmlFor='amount' className='block text-lg font-medium mb-1 text-right'>المبلغ الذي تريد تسديده</label>
                  <input
                    id='amount'
                    type='number'
                    min='0'
                    className='border rounded p-2 w-full'
                    placeholder='ادخل المبلغ الذى تريد تسديده'
                    value={amountToPay}
                    onChange={(e) => setAmountToPay(e.target.value)}
                  />
                </div>

                <button
                  onClick={handlePaymentRequest}
                  className='bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 '
                >
                  تقديم الطلب
                </button>
              </>
            )}
          </div>
        </div>

        <div className='w-full md:w-1/2 pl-0 md:pl-4'>
          {selectedSalesmanDetails.name && (
            <div className='bg-white border rounded-lg shadow-md p-5'>
              <h3 className='text-lg font-bold mb-3 text-center'>تفاصيل الصيدلية </h3>
              <div className='flex items-center mb-3'>
                <img
                  src={selectedSalesmanDetails.profilePic}
                  alt={selectedSalesmanDetails.name}
                  className='w-16 h-16 rounded-full object-cover mr-3'
                />
                <div>
                {selectedSalesmanDetails.name && (
                    <p className='text-lg font-semibold'>{selectedSalesmanDetails.name}</p>
                )}

                {selectedSalesmanDetails.email && (
                    <p className='text-sm text-gray-600'>{selectedSalesmanDetails.email}</p>
                )}

                {selectedSalesmanDetails.mobileNumber && (
                    <p className='text-sm text-gray-600'>
                    {selectedSalesmanDetails.mobileNumber} : رقم هاتف الصيدلية
                    </p>
                )}

                {selectedSalesmanDetails.medicineDebt?.$numberDecimal && (
                    <p className="text-sm text-gray-600">
                    {displayINRCurrency(Number(selectedSalesmanDetails.medicineDebt.$numberDecimal).toFixed(2))} : اجمالي المديونية
                    </p>
                )}

                {selectedSalesmanDetails.governorate && (
                    <p className='text-sm text-gray-600'>
                    {selectedSalesmanDetails.governorate} : المدينة
                    </p>
                )}

                {selectedSalesmanDetails.governorate === 'طرابلس' && selectedSalesmanDetails.region && (
                    <p className='text-sm text-gray-600'>
                    {selectedSalesmanDetails.region} : المنطقة
                    </p>
                )}

                {selectedSalesmanDetails.shippingAddress && (
                    <p className='text-sm text-gray-600'>
                    {selectedSalesmanDetails.shippingAddress} : العنوان
                    </p>
                )}
                </div>

              </div>


            </div>
            
          )}
        </div>
      </div>
    </div>
  );
};

export default SalesmanPaymentRequest;
